/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import GlobalFonts from '../../global/fonts';
import { GlobalStyle } from '../../global/styles';

import { Tokens } from '../../types';

interface ThemeProviderProps {
  theme: any;
  children: any;
}

export const ThemeProvider: React.FC = ({ children, theme }: ThemeProviderProps) => {
  return (
    <StyledThemeProvider theme={(theme && { ...Tokens.eixods, ...theme }) || Tokens.eixods}>
      <GlobalStyle />
      <GlobalFonts />
      {children}
    </StyledThemeProvider>
  );
};
